var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPersonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.9231C24.6732 26.9231 28.4615 23.1347 28.4615 18.4615C28.4615 13.7884 24.6732 10 20 10C15.3268 10 11.5385 13.7884 11.5385 18.4615C11.5385 23.1347 15.3268 26.9231 20 26.9231Z",
    fill: "#1877F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56823 3.03617 8.69181 1.52242 12.3463C0.00866569 16.0008 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9991 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.994 14.6975 37.8849 9.61392 34.1355 5.86449C30.3861 2.11506 25.3025 0.00600149 20 0ZM32.6458 31.2327C31.4108 29.4434 29.8092 27.9374 27.9475 26.8145C25.8067 28.8591 22.9603 30 20 30C17.0397 30 14.1933 28.8591 12.0525 26.8145C10.1908 27.9374 8.58921 29.4434 7.35418 31.2327C5.18593 28.7946 3.76871 25.7817 3.27318 22.5567C2.77766 19.3318 3.22496 16.0324 4.56122 13.0558C5.89748 10.0792 8.06573 7.55234 10.8049 5.77952C13.544 4.0067 16.7372 3.0635 20 3.0635C23.2628 3.0635 26.456 4.0067 29.1951 5.77952C31.9342 7.55234 34.1025 10.0792 35.4387 13.0558C36.775 16.0324 37.2223 19.3318 36.7268 22.5567C36.2313 25.7817 34.814 28.7946 32.6458 31.2327Z",
    fill: "#1877F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPersonBlue);
export default __webpack_public_path__ + "static/media/ico-person-blue.73fae6f5ecace38d886577746cfc830b.svg";
export { ForwardRef as ReactComponent };